import PostTypeIcon from '@/components/post-planning/post/PostTypeIcon';
import { PostsQuery } from '@/graphql/generated/posts.generated';
import { FileFormat, PostType } from '@/graphql/generated/types.generated';
import { getFileFormatByExtension } from '@/utils/files/get-file-format-by-extension.util';
import { ArrayElement } from '@/utils/types/array-element';
import { Avatar, CardMedia, Stack, styled } from '@mui/material';

type PostVariant = 'calendar' | 'list' | 'calendar-preview';

const PostImageContainer = styled(Stack, { shouldForwardProp: (p) => p !== 'postVariant' })<{
    postVariant: PostVariant;
}>(({ postVariant }) => ({
    position: 'relative',
    height: 60,
    width: 60,
    borderRadius: 2,
    ...(postVariant === 'calendar' && {
        height: 80,
        width: '100%',
    }),
    ...(postVariant === 'calendar-preview' && {
        height: '100%',
        maxHeight: '80vh',
        width: '100%',
    }),
}));

const PostTypeAvatar = styled(Avatar, { shouldForwardProp: (p) => p !== 'postVariant' })<{
    postVariant: PostVariant;
}>(({ postVariant }) => ({
    position: 'absolute',
    height: 18,
    width: 18,
    backgroundColor: 'var(--mui-palette-background-paper-elevation-4)',
    padding: 4,
    bottom: 2,
    right: 2,
    ...(postVariant === 'calendar' && {
        height: 28,
        width: 28,
        top: 4,
        right: 4,
    }),
    ...(postVariant === 'calendar-preview' && {
        visibility: 'hidden',
    }),
}));

type PostImageProps = {
    variant?: PostVariant;
    previewMediaLib: ArrayElement<PostsQuery['posts']['items']>['previewMediaLib'];
    type: PostType;
};
const PostImage = ({ variant = 'list', previewMediaLib, type }: PostImageProps) => {
    if (!previewMediaLib) {
        return null;
    }

    const fileType = getFileFormatByExtension(previewMediaLib.preview);
    return (
        <PostImageContainer postVariant={variant}>
            <CardMedia
                component={fileType === FileFormat.Video ? 'video' : 'img'}
                src={previewMediaLib.preview}
                sx={{
                    objectFit: 'cover',
                    objectPosition: 'center',
                    height: '100%',
                    borderRadius: 1,
                }}
                alt="Post preview image"
            />
            <PostTypeAvatar variant="rounded" postVariant={variant}>
                <PostTypeIcon
                    type={type}
                    sx={{
                        ...(variant === 'list' && {
                            fontSize: 16,
                        }),
                    }}
                />
            </PostTypeAvatar>
        </PostImageContainer>
    );
};
export default PostImage;
